// extracted by css-extract-rspack-plugin
export default {"externalSystemIcon":"HeaderCaption_externalSystemIcon__M_2Vn"};